import { render, staticRenderFns } from "./forgetPassword.vue?vue&type=template&id=ac22050e&scoped=true"
import script from "./forgetPassword.vue?vue&type=script&lang=js"
export * from "./forgetPassword.vue?vue&type=script&lang=js"
import style0 from "./forgetPassword.vue?vue&type=style&index=0&id=ac22050e&prod&lang=scss&scoped=true"
import style1 from "./forgetPassword.vue?vue&type=style&index=1&id=ac22050e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac22050e",
  null
  
)

export default component.exports